// tslint:disable-next-line:max-line-length
import type { DirectOrderArticleLineViewModel } from 'src/app/business/direct-order/direct-order-articleline-view-model';

export class TotalPriceCalculator {
  public static calculateArticleTotal(price: string, quantity: number, packagingUnitQuantity?: number): any {
    let total = 0;
    if (price) {
      total += quantity * ((packagingUnitQuantity ? packagingUnitQuantity : 1) * parseFloat(price.replace(/,/g, '.')));
    }
    return total.toFixed(2).toString().replace(/\./g, ',');
  }

  public static calculateDirectOrderArticleLinesTotal(articleLines: DirectOrderArticleLineViewModel[]) {
    let total = 0;
    articleLines?.forEach(orderedArticle => {
      if (orderedArticle.price) {
        total +=
          orderedArticle.quantity *
          ((orderedArticle.packagingUnit?.quantity ? orderedArticle.packagingUnit?.quantity : 1) *
            parseFloat(orderedArticle.price.replace(/,/g, '.')));
      }
    });
    return total.toFixed(2).toString().replace(/\./g, ',');
  }
}
